export const ProcessosAgrupadosTypes = {
  ADD_PROCESSOS_AGRUPADOS: 'ADD_PROCESSOS_AGRUPADOS',
  ADD_PROCESSO_AGRUPADO: 'ADD_PROCESSO_AGRUPADO',
  REMOVE_PROCESSO_AGRUPADO: 'REMOVE_PROCESSO_AGRUPADO',
  REMOVE_PROCESSOS_AGRUPADOS: 'REMOVE_PROCESSOS_AGRUPADOS',
  SET_PROCESSOS_AGRUPADOS: 'SET_PROCESSOS_AGRUPADOS',
  CLEAR_PROCESSOS_AGRUPADOS: 'CLEAR_PROCESSOS_AGRUPADOS'
};
